// extracted by mini-css-extract-plugin
export default {"OrderItemContainer":"OrderItem_OrderItemContainer__wO4j5","ProductImg":"OrderItem_ProductImg__30sey","UpdateProduct":"OrderItem_UpdateProduct__F2hn6"};